const actions = {
  CONTACT_SEND_MESSAGE: 'CONTACT_SEND_MESSAGE',
  CONTACT_SEND_MESSAGE_SUCCESS: 'CONTACT_SEND_MESSAGE_SUCCESS',
  CONTACT_SEND_MESSAGE_FAILURE: 'CONTACT_SEND_MESSAGE_FAILURE',
}

export default actions;
